import { render, staticRenderFns } from "./TwIpRequestProcessList.vue?vue&type=template&id=448e2e92&scoped=true&"
import script from "./TwIpRequestProcessList.vue?vue&type=script&lang=js&"
export * from "./TwIpRequestProcessList.vue?vue&type=script&lang=js&"
import style0 from "./TwIpRequestProcessList.vue?vue&type=style&index=0&id=448e2e92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448e2e92",
  null
  
)

export default component.exports